import { render, staticRenderFns } from "./BuildingInformation.vue?vue&type=template&id=09926a71&"
import script from "./BuildingInformation.vue?vue&type=script&lang=js&"
export * from "./BuildingInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09926a71')) {
      api.createRecord('09926a71', component.options)
    } else {
      api.reload('09926a71', component.options)
    }
    module.hot.accept("./BuildingInformation.vue?vue&type=template&id=09926a71&", function () {
      api.rerender('09926a71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/studentInformation/BuildingInformation.vue"
export default component.exports